<template>
    <div class="introduce-box">
        <ul class="in2">
            <li>
                <div>
                    <img src="/zt/upload_data/2018bg/images/baogao2.png">
                    <span>报告准则</span>
                    <p>坚持客观性、全面性、权威性、专业性基础上，兼顾商业性，力求传播广泛性、各项效果超预期。</p>
                </div>
            </li>
                
            <li>
                <div>
                    <img src="/zt/upload_data/2018bg/images/diaoyan2.png">
                    <span>调研方法</span>
                    <p>平台调研、平台评测、“神秘买家”抽查、供应商与合作伙伴调研、用户调查、政策研究、专家访谈、桌面研究、律师审查等。</p>
                </div>
            </li>
                
            <li>
                <div>
                    <img src="/zt/upload_data/2018bg/images/shuju2.png">
                    <span>数据来源</span>
                    <p>一手调研数据、中心历史数据库、上市公司披露数据、行业公开数据，以及中心合作伙伴、政府部门、科研机构、咨询公司、第方数据监测工具、相关指数、中心采购数据等。</p>
                </div>
            </li>
        </ul>

        <div class="in1">
            <p>浙江网经社信息科技公司有着近20年历史，是中国电商行业的“<span>Bloomberg</span>”。基于数据、专家、媒体、产业链等全方位资源和研究体系，网经社旗下智库“<a href="/Index/dszx.html" target="_blank">电子商务研究中心</a>”每年公开发布超百份电商行业性数据报告，覆盖电商全产业链（<span>零售、服务、产业、跨境、农村、社交</span>等),电商成长周期（<span>创业投融资、千里马、独角兽、新三板、上市公司、巨头</span>）等。</p>
                
            <p>在坚持客观、专业基础上兼顾商业性，在自身研发的“电数宝”数据产品系统监测基础上，采用数据分析、公司和合作伙伴调研、平台评测、用户调查、“神买”抽查、政策研究、专家访谈、律师审查等专业研究方法。</p>

            <p>报告定期向<span>20余个</span>部委、<span>2000+</span>主管部门/协会、<span>30000+</span>电商、<span>1000+</span>专家、<span>3000+</span>记者、<span>20000+</span>投资者等库输出，成为其重要日常数据来源及决策参考依据，是电商行业具影响力、话语权的“风向标”及高层决策智库。</p>

            <p>基于此，我们特发布2019-2020年度报告目录，并将资源开放各大优秀公司合作、共享。报告可用于：<span>投资/创业、并购/IPO、市场调查、汇报引用、数据分析、申报项目、课题研究、竞争者情报、品牌提升、战略咨询</span>等。</p>

            <p>同时，欢迎各电商及相关机构，开展个性化定制，包括不限于：<span>平台年度用户画像与大数据报告、公司案例研究专题研究报告、公司与竞对研究分析投资价值、平台合规性审查报告</span>，以及公司所在细分行业关于<span>平台模式、物流网络、金融科技、用户体验、财务分析、投融资、行业影响力、用户满意度、用户体验评测、平台界面与功能服务评测</span>等细分维度平台大数据报告或行业报告。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Intro'
}
</script>

<style>
/* 简介 */
.introduce-box {
    max-width: 1200px;
    background: #fff;
    padding: 20px;
    margin: 20px auto;
}

.in1 {
    margin-top: 40px;
}

.in1 p {
    position: relative;
    padding-left: 20px;
    margin-bottom: 20px;
}

.in1 p::before {
    content: "";
    width: 10px;
    height: 10px;
    background: dodgerblue;
    position: absolute;
    top: 5px;
    left: 0;
}

.in1 span,
.in1 a {
    color: dodgerblue;
}

.in2 {
    display: flex;
    justify-content: space-around;
}

.in2 li {
    flex: 0 0 28%;
    display: flex;
    justify-content: center;
}

.in2 li img {
    width: 80px;
    margin: auto;
}

.in2 li span {
    display: inherit;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 3px;
    line-height: 3;
    text-align: center;
}

@media(max-width: 1200px) {
    .in1 p {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .in2 {
        display: inherit;
    }

    .in2 li {
        margin-top: 40px;
    }

    .in2 li p {
        font-size: 12px;
    }
}
</style>